import axios, { AxiosRequestConfig } from 'axios'
import axiosRetry from 'axios-retry'

import ErrorBoundary from '../containers/error_boundary'

export const createAxios = (
  config: AxiosRequestConfig = {},
  liveChatApp = false,
) => {
  // eslint-disable-next-line
  // @ts-ignore
  const csrfToken = document.querySelector('meta[name=csrf-token]')?.content
  if (!csrfToken && !window.vitest) {
    ErrorBoundary.logErrorToMyService(new Error('No CSRF Token'))
  }

  const axiosInstance = axios.create({
    ...config,
    headers: {
      'X-CSRF-Token': csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
      ...(config.headers || {}),
    },
  })

  axiosRetry(axiosInstance, { retryDelay: axiosRetry.exponentialDelay })

  axiosInstance.interceptors.response.use(
    (response) => {
      return response
    },
    function (error) {
      ErrorBoundary.logErrorToMyService(
        error || new Error('Undefined error occurred'),
      )

      console.trace()

      if (error && error.response && error.response.status === 401) {
        if (!liveChatApp) {
          setTimeout(() => {
            window.location.reload()
          }, 1)
        }
        return Promise.reject('logged out')
      }

      const formalErrorResponse =
        error.response && error.response.data && error.response.data.error
      if (formalErrorResponse) {
        return Promise.reject(error)
      }

      return Promise.reject(error.toString())
    },
  )

  return axiosInstance
}
